var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('client-only',[_c('loading',{attrs:{"active":true,"can-cancel":false,"is-full-page":true}})],1),_vm._v(" "),(_vm.$fetchState.pending)?_c('div'):_vm._e(),_vm._v(" "),(!_vm.$fetchState.pending && _vm.forceRedirectToCheckoutCartPage())?_c('div'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }